import {Euler, Vector3, Scene} from "three";

const FLOOR_NUMBER = {
    BOTTOM_FLOOR: 1,
    TOP_FLOOR: 2,
};
// Here we split by Artists Names
//ChatRoom01
//ScreenStageLeft
const CameraLocationsDB = [

    // {
    //     cameraLocationId: '',
    //     floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
    //     locationName: '',
    //     cameraPosition: null,
    //     cameraRotation: null,
    //     displayMesh: 'N', //display/hide mesh - applies only on locations set in Blender. Default is 'Y'
    // },
    {
        cameraLocationId: 'ROOM01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Welcome to Lancaster School of Architecture',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'ROOM02',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'TEA talks',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'ROOM08',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'ARCHIextra',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'ROOM03',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'First Year BA (Hons) Architecture',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'ROOM04',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Summer School',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'ROOM05',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Second Year BA (Hons) Architecture',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'ROOM06',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Architectural Technology & Professional Skills',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'ROOM07',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Architectural Humanities',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
    {
        cameraLocationId: 'ROOM01_01',
        floorNumber: FLOOR_NUMBER.BOTTOM_FLOOR,
        locationName: 'Architecture Facilities Tours',
        cameraPosition: null,
        cameraRotation: null,
        displayMesh: 'N',
    },
];

export {CameraLocationsDB, FLOOR_NUMBER};
